import "./heading.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { BaseHeading } from "../../../types/baseHeading";
import FiltersAprovador from "../filters/filtersAprovador";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import PlusButtonFilter from "../../../assets/svgs/plusButtonFilter.svg";

export interface HeadingDashboardOne extends BaseHeading {
  materialData?: {
    sessionId: string;
    productCode: string;
    productSimilarCode?: string | null;
    classificationStatus: string;
    classificationID: string;
  };
}

export const HeadingAprovador = ({
  titlePage,
  titleButton,
  filtros,
  emitentePartNumber,
  setEmitentePartDesc,
  handleFilter,
  setPage,
  onOpen,
}: HeadingDashboardOne) => {
  const [, setIsSimilar] = useState(false);

  const { sessionVerify } = useSelector(
    (state: RootState) => state.sessionInfo
  );

  useEffect(() => {
    if (sessionVerify) {
      setIsSimilar(sessionVerify?.isSimilar);
    }
  }, [sessionVerify]);

  return (
    <div className="containerHeading aprovador">
      <div className="upperHome">
        <div>
          <span className="titleHome">{titlePage}</span>
        </div>
        <div className="buttonsReturn">
          <div>
            <ButtonGeneric
              img={PlusButtonFilter}
              title={titleButton}
              colorTitle="#FFFFFF"
              style="buttonHeading"
              onClick={() => onOpen?.()}
            />
          </div>
        </div>
      </div>

      {filtros && (
        <div>
          <div style={{ height: "35px", marginTop: "10px" }}>
            <span>Filtros</span>
          </div>

          <div>
            <FiltersAprovador
              emitentePartNumber={emitentePartNumber}
              setEmitentePartDesc={setEmitentePartDesc}
              handleFilter={handleFilter}
              setPage={setPage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HeadingAprovador;
